import { useState } from "react";
import {
  List,
  Datagrid,
  TextField,
  SelectField,
  FunctionField,
  EditButton,
  ListActions,
  SimpleList,
  TextInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import {
  DormitoryCampaignApplicantTypes,
  DormitoryCampaignStatuses,
  MOBILE_BREAKPOINT,
  STUDENT_CATEGORIES,
} from "utils/constants";
import { DormitoryCampaignStatusChoices } from "utils/choices";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import EmployeeField from "server/components/Fields/EmployeeField";
import CampaignStatusActions from "./CampaignStatusActions";
import DatagridActions from "../Partials/DatagridActions";
import DormitoryAutocompleteInput from "../Partials/DormitoryAutocompleteInput";
import StudentCategoryTabs from "../Partials/StudentCategoryTabs";
import { formatDateOnlyBg } from "server/formatting/formatDateBg";

const renderApplicationPeriod = record =>
  `${formatDateOnlyBg(record?.documentsFrom)} – ${formatDateOnlyBg(record?.documentsTo)}`;
const renderAccommodationPeriod = record =>
  `${formatDateOnlyBg(record?.accommodationFrom)} – ${formatDateOnlyBg(record?.accommodationTo)}`;
const listFilters = [
  <TextInput
    source="name"
    label="Име"
    alwaysOn
  />,
  <DormitoryAutocompleteInput
    source="status"
    label="Статус"
    choices={DormitoryCampaignStatusChoices}
    alwaysOn
    emptyText="Всички"
  />,
];

const campaignRowActions = record => (
  <>
    {record?.status !== DormitoryCampaignStatuses.Finished &&
      record?.status !== DormitoryCampaignStatuses.Cancelled &&
      checkPermission(getPermissions(), permissions.canManageDormitoryCampaigns) && (
        <EditButton label="Редактирай" />
      )}
    <CampaignStatusActions />
  </>
);

const ListCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [studentCategory, setStudentCategory] = useState(STUDENT_CATEGORIES.INTERNAL);
  const applicantType = studentCategory === STUDENT_CATEGORIES.EXTERNAL
    ? DormitoryCampaignApplicantTypes.External
    : DormitoryCampaignApplicantTypes.Internal;

  return (
    <>
      <StudentCategoryTabs value={studentCategory} onChange={setStudentCategory} />
      <List
        title="Кампании"
        exporter={false}
        filters={listFilters}
        filter={{ applicantType }}
        actions={
          <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageDormitoryCampaigns)} />
        }
      >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record?.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Председател",
                    value: <EmployeeField source="commissionChairEmployeeId" />,
                  },
                ]}
              />
              <MobileListRow
                fields={[{ label: "Срок за кандидатстване", value: renderApplicationPeriod(record) }]}
              />
              <MobileListRow
                fields={[{ label: "Период за настаняване", value: renderAccommodationPeriod(record) }]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: <SelectField source="status" choices={DormitoryCampaignStatusChoices} />,
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => campaignRowActions(record)}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име"
            sortable={false}
          />
          <EmployeeField
            source="commissionChairEmployeeId"
            label="Председател"
            sortable={false}
          />
          <FunctionField
            source="applicationPeriod"
            label="Срок за кандидатстване"
            render={renderApplicationPeriod}
            sortable={false}
          />
          <FunctionField
            source="accommodationPeriod"
            label="Период за настаняване"
            render={renderAccommodationPeriod}
            sortable={false}
          />
          <SelectField
            source="status"
            label="Статус"
            choices={DormitoryCampaignStatusChoices}
            sortable={false}
          />
          <FunctionField
            source="actions"
            label={false}
            sortable={false}
            render={record => <DatagridActions>{campaignRowActions(record)}</DatagridActions>}
          />
        </Datagrid>
      )}
      </List>
    </>
  );
};

export default ListCampaigns;
